import styled from 'styled-components';

const H2 = styled.h2`
    font-size: 28px;
    font-weight: 400;
    color: black;
`;

export default H2;
